import React from "react";
import Navbar from "./Navbar";
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import MainFeature1 from "./TwoColWithButton.js";
import TeamCardGrid from "./ProfileThreeColGrid.js";
import tw from "twin.macro";
import Footer from "./Footer";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
const Subheading = tw.span`uppercase tracking-wider text-sm`;

const AboutUs = () => {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  const team = [
    {
      name: "Utsav Bhardaj",
      position: "CEO",
      desc: "",
      linkedin: "",
      image: "",
    },
  ];

  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <div className="mt-20">
        <Typography
          variant="h3"
          sx={{ fontWeight: "bold", textAlign: "center", color: "#fd1c6c" }}
          gutterBottom
        >
          About Us
        </Typography>
        <Typography
          variant="body1"
          sx={{ width: "800px", textAlign: "justify", mx: "auto" }}
          gutterBottom
        >
          interwiu.com is an online interactive platform developed by Fyzen
          Career Solutions Pvt Ltd, which connects the students (as
          interviewees) with the professionals from top MNCs (as interviewers)
          using a filter-based smart match-making algorithm, to facilitate the
          Mock Interviews with integral Feedback Sessions. The interviewers and
          mentors serving at the platform are the experienced professionals from
          various big MNCs like Microsoft, Amazon, Google, Goldman Sachs,
          McKinsey & Company, IBM, Flipkart, JPMorgan Chase & Co., American
          Express, Meta, Citi, HSBC, Morgan Stanley, Boston Consulting Group
          (BCG), Bain & Company, PwC, Netflix, Directi, IQVIA, Kotak Mahindra
          Bank, BNY Mellon, Hexagon Capability Center India Pvt Ltd, Accenture,
          Deloitte, etc.
        </Typography>
        <Typography
          variant="body1"
          sx={{ width: "800px", textAlign: "justify", mx: "auto" }}
          gutterBottom
        >
          The mock interviews mimic the real placement interviews extensively.
          Via mock interviews, the students learn and practise the exhaustive
          and exclusive approaches required to drive their interviews their way.
          Thus it makes the students confident enough to face and sail through
          the real placement interviews. The personalized feedback session
          following a mock interview helps a student understand and rectify the
          mistakes, realize what went right/wrong, prepare better, improve the
          performance in subsequent mock interviews, and thus ultimately enhance
          the odds of cracking the real placement interviews in a highly
          competitive environment.
        </Typography>
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", textAlign: "center", color: "#fd1c6c" }}
          gutterBottom
        >
          Our Team
        </Typography>
        <Typography
          variant="body1"
          sx={{ width: "800px", textAlign: "justify", mx: "auto" }}
          gutterBottom
        >
          The team of Fyzen Career Solutions Pvt Ltd is composed of young and
          skilled enthusiasts, who are deeply passionate about entrepreneurship.
        </Typography>
        <div
          className="flex p-3 bg-white rounded-lg mx-auto my-4"
          style={{ width: "800px" }}
        >
          <div className="w-60 h-60 rounded-md overflow-hidden">
            <img
              src={require("../../images/utsav.png")}
              className="object-cover h-full w-full"
              alt="Utsav Bhardwaj"
            />
          </div>
          <div className="w-1/2 mx-auto">
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", mb: 0 }}
              gutterBottom
            >
              Utsav Bhardwaj{" "}
              <a
                href="https://www.linkedin.com/in/utsav-bhardwaj-a2131b58/ "
                target="_blank"
                rel="noreferrer"
              >
                <IconButton aria-label="LinkedIn" size="large">
                  <LinkedInIcon fontSize="inherit" />
                </IconButton>
              </a>
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ color: "rgb(116,44,255)", fontWeight: "bold" }}
              gutterBottom
            >
              CEO
            </Typography>
            <Typography variant="body2" gutterBottom>
              He is an alumnus of IIT Madras, and presently a Doctoral Student
              at The University of Queensland, Australia. Earlier, he has worked
              at Eaton India Innovation Center, Pune; and IIT Madras Incubation
              Cell, Chennai.
            </Typography>
          </div>
        </div>
        <div
          className="flex p-3 bg-white rounded-lg mx-auto my-4"
          style={{ width: "800px" }}
        >
          <div className="w-1/2 mx-auto">
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", mb: 0 }}
              gutterBottom
            >
              Rakesk Patil{" "}
              <a
                href="https://www.linkedin.com/in/rarapatil"
                target="_blank"
                rel="noreferrer"
              >
                <IconButton aria-label="LinkedIn" size="large">
                  <LinkedInIcon fontSize="inherit" />
                </IconButton>
              </a>
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ color: "rgb(116,44,255)", fontWeight: "bold" }}
              gutterBottom
            >
              CTO
            </Typography>
            <Typography variant="body2" gutterBottom>
              He is a research scholar at IIT Madras, and has worked earlier as
              a Software Engineer at Intel, Bangalore; and a Graphics Engineer
              at Nvidia, Bangalore.
            </Typography>
          </div>
          <div className="w-60 h-60 rounded-md overflow-hidden">
            <img
              src={require("../../images/rakesh.png")}
              className="object-cover h-full w-full"
              alt="Utsav Bhardwaj"
            />
          </div>
        </div>
        <div
          className="flex p-3 bg-white rounded-lg mx-auto my-4"
          style={{ width: "800px" }}
        >
          <div className="w-60 h-60 rounded-md overflow-hidden">
            <img
              src={require("../../images/photo.png")}
              className="object-cover h-full w-full"
              alt="Utsav Bhardwaj"
            />
          </div>
          <div className="w-1/2 mx-auto">
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", mb: 0 }}
              gutterBottom
            >
              Suryansh Yadav{" "}
              <a
                href="https://www.linkedin.com/in/suryansh-y-96704211b/"
                target="_blank"
                rel="noreferrer"
              >
                <IconButton aria-label="LinkedIn" size="large">
                  <LinkedInIcon fontSize="inherit" />
                </IconButton>
              </a>
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ color: "rgb(116,44,255)", fontWeight: "bold" }}
              gutterBottom
            >
              Full-Stack Developer
            </Typography>
            <Typography variant="body2" gutterBottom>
              Undergraduate Student, IIT Kanpur
            </Typography>
          </div>
        </div>
        <div
          className="flex p-3 bg-white rounded-lg mx-auto my-4"
          style={{ width: "800px" }}
        >
          <div className="w-1/2 mx-auto">
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", mb: 0 }}
              gutterBottom
            >
              Satyaprakash Dewangan{" "}
              <a
                href="https://www.linkedin.com/in/satyadewangan/"
                target="_blank"
                rel="noreferrer"
              >
                <IconButton aria-label="LinkedIn" size="large">
                  <LinkedInIcon fontSize="inherit" />
                </IconButton>
              </a>
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ color: "rgb(116,44,255)", fontWeight: "bold" }}
              gutterBottom
            >
              Full-Stack Developer
            </Typography>
            <Typography variant="body2" gutterBottom>
              Undergraduate Student, Bhilai Institute of Technology (BIT) Durg
            </Typography>
          </div>
          <div className="w-60 h-60 rounded-md overflow-hidden">
            <img
              src={require("../../images/satyaprakash.jpg")}
              className="object-cover h-full w-full"
              alt="Utsav Bhardwaj"
            />
          </div>
        </div>
        <div
          className="flex p-3 bg-white rounded-lg mx-auto my-4"
          style={{ width: "800px" }}
        >
          <div className="w-60 h-60 rounded-md overflow-hidden">
            <img
              src={require("../../images/satyapragnya.jpg")}
              className="object-cover h-full w-full"
              alt="Utsav Bhardwaj"
            />
          </div>
          <div className="w-1/2 mx-auto">
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", mb: 0 }}
              gutterBottom
            >
              Satyapragnya Kar{" "}
              <a
                href="https://www.linkedin.com/in/satyapragnya-kar-118b3221b/"
                target="_blank"
                rel="noreferrer"
              >
                <IconButton aria-label="LinkedIn" size="large">
                  <LinkedInIcon fontSize="inherit" />
                </IconButton>
              </a>
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ color: "rgb(116,44,255)", fontWeight: "bold" }}
              gutterBottom
            >
              Full-Stack Developer
            </Typography>
            <Typography variant="body2" gutterBottom>
              Undergraduate Student, IIT Delhi
            </Typography>
          </div>
        </div>
        <div
          className="flex p-3 bg-white rounded-lg mx-auto my-4"
          style={{ width: "800px" }}
        >
          <div className="w-1/2 mx-auto">
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", mb: 0 }}
              gutterBottom
            >
              Nishakar Kumar{" "}
              <a
                href="https://www.linkedin.com/in/nishakar-kumar-7016451ba/"
                target="_blank"
                rel="noreferrer"
              >
                <IconButton aria-label="LinkedIn" size="large">
                  <LinkedInIcon fontSize="inherit" />
                </IconButton>
              </a>
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ color: "rgb(116,44,255)", fontWeight: "bold" }}
              gutterBottom
            >
              Full-Stack Developer
            </Typography>
            <Typography variant="body2" gutterBottom>
              Undergraduate Student, IIT Kharagpur
            </Typography>
          </div>
          <div className="w-60 h-60 rounded-md overflow-hidden">
            <img
              src={require("../../images/Nishakar.jpg")}
              className="object-cover h-full w-full"
              alt="Utsav Bhardwaj"
            />
          </div>
        </div>
        <div
          className="flex p-3 bg-white rounded-lg mx-auto my-4"
          style={{ width: "800px" }}
        >
          <div className="w-60 h-60 rounded-md overflow-hidden">
            <img
              src={require("../../images/vaibhav.png")}
              className="object-cover h-full w-full"
              alt="Utsav Bhardwaj"
            />
          </div>
          <div className="w-1/2 mx-auto">
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", mb: 0 }}
              gutterBottom
            >
              Mr. Vaibhav Goyal{" "}
              <a
                href="https://www.linkedin.com/in/vaibhavg/"
                target="_blank"
                rel="noreferrer"
              >
                <IconButton aria-label="LinkedIn" size="large">
                  <LinkedInIcon fontSize="inherit" />
                </IconButton>
              </a>
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ color: "rgb(116,44,255)", fontWeight: "bold" }}
              gutterBottom
            >
              Mentor
            </Typography>
            <Typography variant="body2" gutterBottom>
              He is an alumnus of IIT Madras and SP Jain Institute of Management
              & Research. He holds a sound professional experience of around 19
              years, distributed across various technological roles at firms
              like Nokia, DigiVive, Hungama, Jio, Shemaroo Entertainment Ltd.,
              etc.
            </Typography>
          </div>
        </div>
      </div>
      <TeamCardGrid subheading={<Subheading>Our Team</Subheading>} />
      <Footer />
    </>
  );
};
export default AboutUs;
